import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import app from 'flarum/forum/app';
import Modal from 'flarum/common/components/Modal';
import Button from 'flarum/common/components/Button';
export default class ReportPlayerErrorModal extends Modal {
  constructor() {
    super(...arguments);
    _defineProperty(this, "player", null);
    _defineProperty(this, "description", '');
    _defineProperty(this, "submitting", false);
  }
  oninit(vnode) {
    super.oninit(vnode);
    const attrs = vnode && vnode.attrs || this.attrs || {};
    this.player = attrs.player || null;
    this.description = '';
    this.submitting = false;
  }
  className() {
    return 'ReportPlayerErrorModal Modal--small';
  }
  title() {
    var _this$player;
    const playerName = ((_this$player = this.player) == null ? void 0 : _this$player.name) || '';
    return app.translator.trans('bizkaitarra-lineup.forum.players_directory.report_modal.title_with_name', {
      name: playerName
    }) || "Reportar error: ".concat(playerName);
  }
  content() {
    var _this$player2;
    const playerName = ((_this$player2 = this.player) == null ? void 0 : _this$player2.name) || 'este jugador';
    return m("div", {
      className: "Modal-body",
      style: "padding: 24px;"
    }, m("p", {
      style: "margin: 0 0 16px 0; color: var(--muted-color); font-size: 0.95em; line-height: 1.45;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.report_modal.desc', {
      name: playerName
    })), m("form", {
      onsubmit: e => this.onsubmit(e)
    }, m("div", {
      className: "Form-group",
      style: "margin-bottom: 20px;"
    }, m("label", {
      style: "font-weight: 700; margin-bottom: 8px; display: block; color: var(--heading-color);"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.report_modal.label_text'), " *"), m("textarea", {
      className: "FormControl",
      rows: 4,
      placeholder: app.translator.trans('bizkaitarra-lineup.forum.players_directory.report_modal.placeholder'),
      value: this.description,
      oninput: e => {
        this.description = e.target.value;
      },
      disabled: this.submitting,
      style: "border-radius: 8px; resize: vertical; font-size: 0.95em; padding: 10px;",
      required: true
    })), m("div", {
      className: "Form-group",
      style: "display: flex; justify-content: flex-end; gap: 10px; margin-top: 24px;"
    }, m(Button, {
      className: "Button",
      onclick: () => app.modal.close(),
      disabled: this.submitting,
      style: "border-radius: 8px;"
    }, app.translator.trans('bizkaitarra-lineup.forum.players_directory.report_modal.btn_cancel')), m(Button, {
      type: "submit",
      className: "Button Button--primary",
      loading: this.submitting,
      disabled: !this.description || !this.description.trim(),
      style: "border-radius: 8px; font-weight: bold;"
    }, m("i", {
      className: "fas fa-paper-plane",
      style: "margin-right: 6px;"
    }), app.translator.trans('bizkaitarra-lineup.forum.players_directory.report_modal.btn_submit')))));
  }
  onsubmit(e) {
    var _this$player3;
    e.preventDefault();
    const trimmed = this.description ? this.description.trim() : '';
    if (!trimmed) {
      return;
    }
    const playerId = (_this$player3 = this.player) == null ? void 0 : _this$player3.id;
    if (!playerId) {
      app.alerts.show({
        type: 'error'
      }, 'ID de jugador no válido.');
      return;
    }
    this.submitting = true;
    m.redraw();
    app.request({
      method: 'POST',
      url: app.forum.attribute('apiUrl') + '/taldezaina/player-error-report',
      body: {
        playerId: Number(playerId),
        description: trimmed
      }
    }).then(res => {
      this.submitting = false;
      app.modal.close();
      const successMsg = app.translator.trans('bizkaitarra-lineup.forum.players_directory.report_modal.success') || '¡Gracias! El reporte ha sido enviado al equipo de Taldezainak.';
      app.alerts.show({
        type: 'success'
      }, successMsg);
      if (res && res.meta && typeof res.meta.pendingCount !== 'undefined') {
        if (!app.forum.data.attributes) {
          app.forum.data.attributes = {};
        }
        app.forum.data.attributes.pendingTaldezainaTasksCount = res.meta.pendingCount;
      }
      m.redraw();
    }).catch(err => {
      var _err$response$errors$;
      this.submitting = false;
      m.redraw();
      console.error('Error enviando reporte de jugador:', err);
      let msg = app.translator.trans('bizkaitarra-lineup.forum.players_directory.report_modal.error');
      if (err && err.response && err.response.errors && (_err$response$errors$ = err.response.errors[0]) != null && _err$response$errors$.detail) {
        msg = err.response.errors[0].detail;
      }
      app.alerts.show({
        type: 'error'
      }, msg);
    });
  }
}
flarum.reg.add('nagusi-match-ratings', 'forum/match-rating/ReportPlayerErrorModal', ReportPlayerErrorModal);